import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { IsNullOrEmpty } from "shared/helpers/NullEmptyHelpers";
import { GetCustomError } from "shared/helpers/AxiosHelpers";

import { useQuery } from "@tanstack/react-query";

const url = "api/File/GetExcelExportAsString";
const dataKey = "useFetchExportDataResultKey";

export function useFetchExportData(apiParams, onError) {
  const { oktaAuth } = useOktaAuth();

  async function GetExportDownloadsData() {
    const accessToken = oktaAuth.getAccessToken();

    var result = await axios
      .get(url, {
        params: apiParams,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        let thisError = GetCustomError(error);

        if (onError) onError(thisError);

        throw thisError;
      });

    return result;
  }

  function IsEnabled() {
    if (IsNullOrEmpty(apiParams)) return false;

    return true;
  }

  return useQuery({
    queryKey: [dataKey, url, apiParams],
    queryFn: async () => await GetExportDownloadsData(),
    enabled: IsEnabled,
  });
}
